import { TConsolePermissions } from "@Console/permissions/types";

export const checkPermission = (
  roles: string[],
  permission: TConsolePermissions,
): boolean => {
  return roles?.includes(permission);
};
